import { V2 } from "@ui/theme/DesignV2"
import { FC, useMemo } from "react"
import { Error } from "@ui/error/Error"
import Panel from "@ui/panel/Panel"
import { S_UNIVERSAL_DIALOG } from "./signals"
import { UniversalDialogContext } from "./dialogContext"

const BASE_SX = {
	width: "min(720px, calc(100vw - 32px))",
	maxWidth: "720px",
	minWidth: "min(440px, calc(100vw - 32px))",
	maxHeight: "calc(100dvh - 32px)",
	overflow: "hidden",
	transition: "opacity .2s, transform .2s",
	borderRadius: V2.dialogRadius,
	border: "1px solid rgba(226, 232, 240, 0.95)",
	backgroundColor: "#FFFFFF",
	boxShadow: "0 24px 64px rgba(15, 23, 42, 0.22), 0 8px 20px rgba(15, 23, 42, 0.08)",
	fontFamily: "Euclid, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
	"@media (min-width: 769px) and (min-height: 501px), (min-width: 1001px)": {
		"&:not([data-dialog-layout-mode='side']):has([data-form-parser]):not(:has([data-dialog-layout='compact-form'])), &:not([data-dialog-layout-mode='side']):has([data-dialog-layout='amount-form'])": {
			width: "min(560px, calc(100vw - 32px))",
			maxWidth: "560px"
		},
		"&:not([data-dialog-layout-mode='side']):has([data-dialog-layout='compact-form'])": {
			width: "min(680px, calc(100vw - 32px))",
			maxWidth: "680px"
		}
	}
}

const DIALOG_WIDTHS = {
	small: "520px",
	medium: "720px",
	large: "900px"
} as const

export const UniversalDialog: FC = () => {
	const dialogData = S_UNIVERSAL_DIALOG.use([])

	const sx = useMemo(() => {
		const width = DIALOG_WIDTHS[dialogData?.size ?? "medium"]
		return {
			...BASE_SX,
			width: `min(${width}, calc(100vw - 32px))`,
			maxWidth: width,
			...dialogData?.sx
		}
	}, [dialogData?.size, dialogData?.sx])

	if (!dialogData) return null

	const { closeDialog, label, busy, error, content, contentPadding } = dialogData

	return (
		<Panel
			sx={sx}
			busy={busy}
			decorator='absolute'
			desktopPlacement={dialogData.placement ?? "center"}
			desktopWidth={dialogData.size === "large" ? "760px" : "600px"}
			label={label}
			onBack={dialogData.onBack
				?? (S_UNIVERSAL_DIALOG.canGoBack() && !dialogData.hideHistoryBack
					? () => S_UNIVERSAL_DIALOG.back()
					: undefined)}
			onClose={closeDialog}
			contentPadding={contentPadding}
			growContent
			scrollable
		>
			<UniversalDialogContext.Provider value={true}>
				{Boolean(error) && <Error error={error} />}
				{content}
			</UniversalDialogContext.Provider>
		</Panel>
	)
}
